import { useState, useEffect } from "react";
import POSDashboard from "../../components/routes/POSDashboard";

export default function POSPage() {

  const [period, setPeriod] = useState<'day' | 'week' | 'month' | 'year'>('day');
  
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      const { name, value } = e.target;
      setPeriod(value as 'day' | 'week' | 'month' | 'year');
    };
  
    useEffect(() => {
      console.log('SalesPage component mounted');
    }, [period]);
  
    
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-6">POS Dashboard</h1>
              <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Period</label>
          <select
            name="period"
            value={period}
            onChange={handleChange}
            className="w-full p-2 border rounded"
          >
            <option value="">Select Period</option>
           <option key={'day'} value={'day'}>
                {"1 day"}
              </option>
              <option key={'week'} value={'week'}>
                {"1 Week"}
              </option>
              <option key={'month'} value={'month'}>
                {"1 Month"}
              </option>
              <option key={'year'} value={'year'}>
                {"1 Year"}
              </option>
          </select>
        </div>

      <POSDashboard timeRange={period} />
    </div>
  );
}